import swal from 'sweetalert';

export const errorSwal = async (msg) => await swal('Error', msg, 'error');

export const warningSwal = async (msg) => await swal('Warning', msg, 'warning');
